import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { Seller, SellersService, ListSellersParams } from 'src/app/core/sellers.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { ERROR_SELLER_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-sellers-data',
  templateUrl: './sellers-data.component.html',
  styleUrls: ['./sellers-data.component.scss'],
})
export class SellersDataComponent {
  @ViewChild('seller_load_more') load_more_layout?: ElementRef;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = true;
  is_load_more_running: boolean = true;
  sellers?: Seller[];
  cursor: string | null = null;
  total?: number;
  filters?: ListSellersParams;

  constructor(private sellers_service: SellersService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.sellers = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listSellers();
  }

  onRefresh(): void {
    this.sellers = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listSellers();
  }

  onFilter(filters?: ListSellersParams): void {
    this.sellers = [];
    this.cursor = null;
    this.filters = filters;
    this.total = undefined;
    this.listSellers(filters);
  }

  onScrollEnd(): void {
    if (this.cursor && !this.is_load_more_running) this.onLoadMoreClick();
  }

  onLoadMoreClick(): void {
    this.listSellers(this.filters, true);
  }

  listSellers(filters?: ListSellersParams, is_load_more_running?: boolean): void {
    this.is_list_running = !is_load_more_running;
    this.is_load_more_running = is_load_more_running || false;

    const list_sellers_params = {
      ...filters,
      cursor: this.cursor,
    };

    this.sellers_service.listSellers(list_sellers_params).subscribe({
      next: response => {
        const sellers = response.data.data;
        this.sellers = (this.sellers ? this.sellers : []).concat(sellers);
        this.cursor = response.data.cursor;
        if (list_sellers_params.cursor == undefined) {
          this.total = response.data.total.value;
        }

        this.is_list_running = false;
        this.is_load_more_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_SELLER_NOT_FOUND) {
          this.sellers = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
    });
  }
}
